import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { WishlistProvider } from "./context/WishlistContext";
import ToastProvider from "./components/common/ThemeToaster.jsx";
import { store } from "./store";
import App from "./App.jsx";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <WishlistProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </WishlistProvider>
    </Provider>
  </React.StrictMode>,
);
